import React from "react";
import ChannelIcon from "../ChannelIcon";

const ConnectionIcon = ({ connectionType, width, height, className }) => {
  return (
    <ChannelIcon
      channel={connectionType}
      style={{
        marginBottom: "-5px",
        fontSize: width ? `${width}px` : "20px",
      }}
    />
  );
};

export default ConnectionIcon;
